import {request} from './client.js'

/**
 * @param {{status?: 'open'|'all', assigneeId?: string}} [filters]
 * @return {Promise<{issues: import('./types.js').Issue[]}>}
 */
export function listIssues(filters = {}) {
    const qs = new URLSearchParams()
    if (filters.status)
        qs.set('status', filters.status)
    if (filters.assigneeId)
        qs.set('assigneeId', filters.assigneeId)
    const suffix = qs.toString() ? `?${qs}` : ''
    return request('GET', `/issues${suffix}`)
}

/**
 * @param {string} id
 */
export function getIssue(id) {
    return request('GET', `/issues/${id}`)
}

/**
 * @param {{title: string, description: string, severity: import('./types.js').IssueSeverity, subsystem: string, images?: File[]}} payload
 */
export function createIssue(payload) {
    const form = new FormData()
    form.set('title', payload.title)
    form.set('description', payload.description)
    form.set('severity', payload.severity)
    form.set('subsystem', payload.subsystem)
    for (const img of payload.images || [])
        form.append('images', img)
    return request('POST', '/issues', {body: form})
}

/**
 * @param {string} id
 * @param {string} body
 */
export function addIssueComment(id, body) {
    return request('POST', `/issues/${id}/comments`, {body: {body}})
}

/**
 * @param {string} id
 * @param {import('./types.js').IssueStatus} status
 */
export function setIssueStatus(id, status) {
    return request('POST', `/issues/${id}/status`, {body: {status}})
}
